import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=026eb4ac&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=ts"
export * from "./DocumentsView.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=026eb4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026eb4ac",
  null
  
)

export default component.exports